import { render, staticRenderFns } from "./GenericPage.vue?vue&type=template&id=8b36b646&"
import script from "./GenericPage.vue?vue&type=script&lang=js&"
export * from "./GenericPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports